












import { Vue, Component, Prop } from "vue-property-decorator";
import CardTitle from "../../components/CardTitle.vue";
import JobsDataTable from "../../components/DataTables/JobsDataTable.vue";
import * as user from "../../_store/user.module";
import * as auth from "../../_store/auth.module";
import * as temp from "../../_store/temp.module";
import { bus } from "../../main";
import { userUtils } from "../../_utils/userUtils";
import DetailsDataTable from "../../components/DataTables/DetailsDataTable.vue";

import * as data from "../../_store/data.module";

@Component({
    components: {
        CardTitle,
        DetailsDataTable
    }
})
export default class Apprendistati extends Vue {
    private titleParams: object;
    private dataTableParams: any;
    private createDialogParams: object;

    private listaApprendistati: any;

    constructor() {
        super();
        this.titleParams = {
            title: "Apprendistati",
            cols: "10",
            sm: "5",
            md: "5",
            lg: "4"
        };
        this.dataTableParams = {
            headers: [
                {
                    text: "Nome Allievo",
                    value: "nomeUtente"
                },
                {
                    text: "Cognome Allievo",
                    value: "cognomeUtente"
                },
                {
                    text: "Classe",
                    value: "classe"
                },
                {
                    text: "Specializzazione",
                    value: "nomeArticolazione"
                },
                {
                    text: "Ditta",
                    value: "denominazioneAzienda"
                },
                {
                    text: "Comune Ditta",
                    value: "comuneAzienda"    
                },
                {
                    text: "Tipo Contratto",
                    value: "tipoContratto"
                },
                {
                    text: "Da Tirocinio",
                    value: "daTirocinio"
                },
                {
                    text: "Data Inizio",
                    value: "dsDataInizio"
                },
                {
                    text: "Data Fine",
                    value: "dsDataFine"
                },
                {
                    text: "Dettagli",
                    value: "dettagliApprendistato" 
                },
                {
                    text: "Modifica",
                    value: "editApprendistato",
                    width: "1%"
                },
                {
                    text: "Elimina",
                    value: "deleteApprendistato",
                    width: "1%"
                }
            ],
            records: [],
            dialogParams: {
				title: "DETTAGLI ALLIEVO",
				type: "userTab"
			},
            apprendistatoDialogParams: {
                title: "DETTAGLI APPRENDISTATO",
                type: "apprendistatoTab"
            },
            filterType: "listaApprendistati"
        };
		this.createDialogParams = {
			visible: true,
			type: "nuovoApprendistato"
		};
    }

    loadApprendistati(idAnnoScolastico: number) {
        var instituteInfo = user.readInstituteInfo(this["$store"]);

        var payload = {
            idIstituto: instituteInfo.id,
            idAnnoScolastico: idAnnoScolastico,
        }
        data
            .dispatchGetApprendistati(this["$store"], payload)
            .then(result => {
                this.dataTableParams.records = result;
                this.listaApprendistati = result;
                bus.$emit("dataLoaded");
            })
            .catch(error => {
                if (error.response.status === 401) {
                    bus.$emit("errorOperation", error.response.statusText);
                    this["$router"].push("/login");
                } else {
                    bus.$emit("errorOperation", "Errore nel caricamento lista azienda");
                }
            });
    }

    created() {
		var idAnnoScolastico = temp.readIdAnnoScolastico(this["$store"]);
		var token = localStorage.getItem("userToken");
		var parsedToken: any;
		if (token !== null) {
			parsedToken = userUtils.parseToken(token);
		}
		var payload = {
			idUtente: parsedToken.IdUtente,
			tipoSoggetto: parsedToken.IdTipoSoggetto,
			username: parsedToken.Username
		};
        user
            .dispatchSetUserInfo(this["$store"], payload)
            .then(() => {
				user
					.dispatchSetInstituteInfo(this["$store"])
					.then(() => {
                        this.loadApprendistati(idAnnoScolastico);
						bus.$emit("loadMenu");
					})
					.catch(() => {
						bus.$emit("stopLoading");
						auth.dispatchLogout(this["$store"]);
						user.dispatchClearState(this["$store"]);
						this["$router"].push("/sessionExpired");
					});
            })
            .catch(() => {
                bus.$emit("stopLoading");
                auth.dispatchLogout(this["$store"]);
                user.dispatchClearState(this["$store"]);
                this["$router"].push("/sessionExpired");
            });

        bus.$on("loadApprendistati", () => {
            var idAnnoScolastico = temp.readIdAnnoScolastico(this["$store"]);
            this.loadApprendistati(idAnnoScolastico);
        })

        bus.$on("changeAnnoScolastico", (payload: any) => {
            this.loadApprendistati(payload);
        });
    }
}
